import { useCallback, useMemo } from 'react';
import type { ConversationAttributeItem } from '@/entities/attributes';
import { useConversationsAttributes } from '@/entities/conversations';
import { useSettings } from '@/entities/settings';

/** Атрибутов нет: стабильная ссылка, пока ответ их не дал */
const EMPTY_ATTRIBUTES: ConversationAttributeItem[] = [];

export const useAttributesSettings = (params?: { 'attribute-group-code'?: string }) => {
  const { data, isLoading: isLoadingAttributes } = useConversationsAttributes({
    'is-deleted': false,
    limit: 1000,
    'attribute-group-code': params?.['attribute-group-code'],
  });

  // Состав колонок списка строится из атрибутов, поэтому набор должен переживать рендеры: пока
  // ответ атрибутов не дал, каждый рендер иначе получал бы новый пустой набор — и колонки
  // пересобирались бы заново
  const attributes = data?.attributes ?? EMPTY_ATTRIBUTES;

  // Храним path атрибутов в настройках
  const { dialogsPage, setDialogsSettings } = useSettings();
  const selectedPaths = useMemo(
    () => [...(dialogsPage.attributes || []), ...(dialogsPage.mainColumns || [])],
    [dialogsPage.attributes, dialogsPage.mainColumns],
  );

  const selectAttributes = useCallback(
    (paths: string[]) => {
      setDialogsSettings({ attributes: paths });
    },
    [setDialogsSettings],
  );

  const selected = useMemo(
    () => attributes.filter((attr) => selectedPaths.includes(attr.path)),
    [attributes, selectedPaths],
  );

  return {
    selected,
    selectedPaths,
    selectAttributes,
    attributes,
    isLoadingAttributes,
  };
};
